import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileDown, Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

// One-page client PDF (risk + strategy) in the case country's language
export const ClientReportPanel = ({ matter }) => {
  const { api } = useAuth();
  const [tone, setTone] = useState('simple');
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/cerebro/matters/${matter.id}/client-report?tone=${tone}`, {}, { responseType: 'blob', timeout: 180000 });
      const a = document.createElement('a'); a.href = URL.createObjectURL(r.data); a.download = `Informe cliente - ${matter.title.slice(0, 50)}.pdf`; a.click();
      toast.success('Informe listo para enviar al cliente');
    } catch { toast.error('No se pudo generar el informe'); } finally { setBusy(false); }
  };
  const opt = (v, label, desc) => (
    <button data-testid={`client-report-tone-${v}`} onClick={() => setTone(v)} className={`flex-1 rounded-xl border p-3 text-left transition-colors ${tone === v ? 'border-amber-500 bg-amber-500/10' : 'border-slate-700 hover:border-slate-500'}`}>
      <p className="text-sm font-semibold text-white">{label}</p><p className="text-xs text-slate-400">{desc}</p>
    </button>
  );
  return (
    <div className="space-y-3 pt-3" data-testid="client-report-panel">
      <div className="flex gap-2">
        {opt('simple', 'Simple', 'Lenguaje claro, sin tecnicismos')}
        {opt('tecnico', 'Técnico', 'Normas, juez y táctica procesal')}
      </div>
      <p className="text-xs text-slate-400">Una página con probabilidad estimada, riesgo, plan, próximos pasos y lo que necesitas del cliente, en el idioma del país del caso. {!matter.ai_win_probability && 'Genera primero la estrategia para incluir la probabilidad.'}</p>
      <button data-testid="client-report-download" onClick={download} disabled={busy} className="w-full rounded-lg bg-amber-500 py-2 text-sm font-semibold text-slate-950 hover:bg-amber-400 disabled:opacity-60 flex items-center justify-center gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}{busy ? 'Redactando informe (≈30 s)...' : 'Descargar informe PDF'}
      </button>
    </div>
  );
};
